var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("UiButton", {
        attrs: { buttonText: "Resource request" },
        on: {
          click: function ($event) {
            _vm.modalShown = true
          },
        },
        scopedSlots: _vm._u([
          {
            key: "icon",
            fn: function () {
              return [
                _c("PlusIcon", { staticClass: "fill-current w-2.5 h-2.5" }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm.modalShown
        ? _c("CustomRequestModal", {
            attrs: {
              currentUserId: _vm.currentUserId,
              companyId: _vm.companyId,
              skills: _vm.initialSkillIds,
              outerProcessing: _vm.processing,
              outerHandler: "",
            },
            on: {
              create: _vm.create,
              close: function ($event) {
                _vm.modalShown = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }